import { render, staticRenderFns } from "./CreateCompetition.vue?vue&type=template&id=5076b934&scoped=true"
import script from "./CreateCompetition.vue?vue&type=script&lang=js"
export * from "./CreateCompetition.vue?vue&type=script&lang=js"
import style0 from "./CreateCompetition.vue?vue&type=style&index=0&id=5076b934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5076b934",
  null
  
)

export default component.exports